const API_URL = process.env.REACT_APP_API_URL

const CONSTANTS = {
	COMPASS_BASEURL: 'https://compass.globe.com.ph/v2.0.13',

	ACCESS_MANAGEMENT_API_URL: API_URL + '/userAccess',
	ACTIVE_DIRECTORY_API_URL: API_URL + '/groups',
	AD_APPROVAL_CALLBACK_API_URL: API_URL + '/adgitops-approve',
	// Grafana facts callback is intentionally disabled. The backend now creates
	// Grafana facts MRs directly and sends recipients a Grafana login notice.
	// AD_GRAFANA_FACTS_CALLBACK_API_URL:
	// 	API_URL + '/adgitops-grafana-facts-confirm',
	PROJECTS_API_URL: API_URL + '/projects',
	ACCOUNTS_API_URL: API_URL + '/accounts',
	TAGS_API_URL: API_URL + '/tags',
	TAG_DETAILS_API_URL: API_URL + '/tag-details',
	PLATFORMS_API_URL: API_URL + '/platforms',
	APPLICATIONS_API_URL: API_URL + '/applications',
	GCPPROJECTS_API_URL: API_URL + '/gcpProjects',
	GCPCERTS_API_URL: API_URL + '/gcpCerts',
	MONGODB_API_URL: API_URL + '/mongodb',
	RHOCPTENANTS_API_URL: API_URL + '/rhocpTenants',
	PROJECT_RESOURCE_API_URL: API_URL + '/projectResources',
	CLUSTERS_API_URL: API_URL + '/clusters',
	MULTI_TENANT_REQUESTS_API_URL: API_URL + '/multiTenantRequests',
	MICROSERVICES_API_URL: API_URL + '/microservices',
	APIS_API_URL: API_URL + '/apis',

	PROJECT_APPROVER: ['projects:*:approve', 'projects:*:read'],
	PROJECT_READER: ['projects:*:read'],
	PROJECT_REQUESTOR: ['projects:*:create', 'projects:*:read'],

	PLATFORM_APPROVER: ['platforms:*:approve', 'platforms:*:read'],
	PLATFORM_READER: ['platforms:*:read'],
	PLATFORM_REQUESTOR: ['platforms:*:create', 'platforms:*:read'],

	APPLICATION_APPROVER: ['applications:*:approve', 'applications:*:read'],
	APPLICATION_READER: ['applications:*:read'],
	APPLICATION_REQUESTOR: ['applications:*:create', 'applications:*:read'],

	ACCOUNT_APPROVER: ['accounts:*:approve', 'accounts:*:read', 'tags:*:read'],
	/** Shown on account / STG UI: SSP permission triples required to approve or reject STG follow-up (matches authorizer stg_approve / stg_reject). */
	ACCOUNT_STG_APPROVER_SSP_HINT:
		'SSP requires both accounts:*:approve and accounts:*:read on the accounts resource (same as standard account onboarding approval). Reject uses POST action stg_reject; approve uses stg_approve. Wildcards such as accounts:*:* or *:*:* satisfy these checks when configured for your user.',
	ACCOUNT_READER: ['accounts:*:read', 'tags:*:read'],
	ACCOUNT_REQUESTOR: ['accounts:*:create', 'accounts:*:read', 'tags:*:read'],

	TAG_APPROVER: ['tags:*:approve', 'tags:*:read'],
	TAG_READER: ['tags:*:read'],
	TAG_REQUESTOR: ['tags:*:create', 'tags:*:read'],

	GCPPROJECT_APPROVER: ['gcpProjects:*:approve', 'gcpProjects:*:read'],
	GCPPROJECT_READER: ['gcpProjects:*:read'],
	GCPPROJECT_REQUESTOR: ['gcpProjects:*:create', 'gcpProjects:*:read'],

	GCP_CERT_APPROVER: ['gcpCerts:*:approve', 'gcpCerts:*:read'],
	GCP_CERT_READER: ['gcpCerts:*:read'],
	GCP_CERT_REQUESTOR: ['gcpCerts:*:create', 'gcpCerts:*:read'],

	MONGODB_APPROVER: ['mongodb:*:approve', 'mongodb:*:read'],
	MONGODB_READER: ['mongodb:*:read'],
	MONGODB_REQUESTOR: ['mongodb:*:create', 'mongodb:*:read'],

	RHOCPTENANT_APPROVER: ['rhocpTenants:*:approve', 'rhocpTenants:*:read'],
	RHOCPTENANT_READER: ['rhocpTenants:*:read'],
	RHOCPTENANT_REQUESTOR: ['rhocpTenants:*:create', 'rhocpTenants:*:read'],

	MICROSERVICE_APPROVER: ['microservices:*:approve', 'microservices:*:read'],
	MICROSERVICE_READER: ['microservices:*:read'],
	MICROSERVICE_REQUESTOR: ['microservices:*:create', 'microservices:*:read'],

	API_APPROVER: ['apis:*:approve', 'apis:*:read'],
	API_READER: ['apis:*:read'],
	API_REQUESTOR: ['apis:*:create', 'apis:*:read'],

	CLUSTER_APPROVER: ['clusters:*:approve', 'clusters:*:read'],
	CLUSTER_READER: ['clusters:*:read'],
	CLUSTER_REQUESTOR: ['clusters:*:create', 'clusters:*:read'],

	USERACCESS_APPROVER: ['useraccess:*:update', 'useraccess:*:read'],
	USERACCESS_READER: ['useraccess:*:read'],
	USERACCESS_REQUESTOR: ['useraccess:*:create', 'useraccess:*:read'],

	ACCESS_MANAGER: [
		'useraccess:*:update',
		'useraccess:*:create',
		'useraccess:*:delete'
	],
	COST_TYPE_LIST: [
		{ label: 'CapEx', value: 'capex' },
		{ label: 'OpEx', value: 'opex' }
	],

	PLATFORM_REPO_LIST: [
		{ label: 'Mono Repo', value: 'monorepo' },
		{ label: 'Multi Repo', value: 'multirepo' }
	],
	DATA_CLASSIFICATION_LIST: [
		{ label: 'CONFIDENTIAL-PERSONAL', value: 'confidential-personal' },
		{ label: 'CONFIDENTIAL-PROPRIETARY', value: 'confidential-proprietary' },
		{ label: 'PRIVATE', value: 'private' },
		{ label: 'PUBLIC', value: 'public' }
	],
	DEPLOYMENT_LIST: [
		{label: 'PROD-PREP', value: 'prod-prep'},
		{label: 'STAGING-PREP', value: 'staging-prep'},
		{label: 'DEV-PREP', value: 'dev-prep'},
		{label: 'SB-PREP', value: 'sb-prep'},
	],
	TIER_LEVEL_OPTIONS: [
		{ label: '1', value: '1' },
		{ label: '2a', value: '2a' },
		{ label: '2b', value: '2b' },
		{ label: '3', value: '3' },
		{ label: 'nonprod', value: 'nonprod' }
	],
	APPROVER_TEAMS: ['PlatformOwner', 'FinanceTeam', 'CloudEconomicsTeam'],
	PLATFORM_OWNER: ['PlatformOwner'],
	CERT_TYPE_OPTIONS: [
		{ label: 'Wildcard', value: 'wildcard' },
		{ label: 'Domain', value: 'domain' },
		{ label: 'Domain & Wildcard', value: 'both' }
	],
	CA_ANALYSIS_FREQUENCY_OPTIONS: [
		{ label: 'None', value: 'none' },
		{ label: 'Daily', value: 'daily' },
		{ label: 'Weekly', value: 'weekly' },
		{ label: 'Monthly', value: 'monthly' }
	],
	SUBNET_RESOURCE_TYPE_OPTIONS: [
		{ label: 'VM', value: 'VM' },
		{ label: 'PSA', value: 'PSA' },
		{ label: 'PSC', value: 'PSC' },
		{ label: 'VPC Connector', value: 'VPC Connector' },
		{ label: 'Composer', value: 'Composer' },
		{ label: 'Dataflow', value: 'Dataflow' },
		{ label: 'Dataproc', value: 'Dataproc' },
		{ label: 'Vertex AI', value: 'Vertex AI' },
		{ label: 'ILB (Internal Load Balancer)', value: 'ILB' },
		{ label: 'Direct VPC egress', value: 'Direct VPC egress' }
	],
	COMMON_NETWORK_VPCS: [
		'glo-cmn-net-vpc-intrcnnct-ui34',
		'glo-ccm-net-vpc-sn41'
	],
	// Purpose suggestions for PSA; free text is also allowed.
	PSA_PURPOSE_OPTIONS: [
		{ value: 'cloudsql' },
		{ value: 'alloydb' },
		{ value: 'redis' },
		{ value: 'filestore' },
		{ value: 'vertexai' }
	],
	// Common Network subnets are PSC only (MongoDB and Confluent private endpoints).
	COMMON_NETWORK_RESOURCE_TYPE_OPTIONS: [{ label: 'PSC', value: 'PSC' }],
	// Purpose suggestions for PSC; free text is also allowed.
	PSC_PURPOSE_OPTIONS: [
		{ value: 'mongodb' },
		{ value: 'confluent' }
	]
}

export default CONSTANTS
